module.exports = __webpack_public_path__ + "img/speechsound.98ae6f73.gif";